/*
|--------------------------------------------------------------------------
| Import Common Libraries (lodash, axios etc)
|--------------------------------------------------------------------------
*/

// Lots of helper functions
window._ = require('lodash');

// Axios for Ajax (instead of jQuery)
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// setting CSRF token here globally, so not every request has to
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    let token = document.querySelector('meta[name="csrf-token"]');
    if(token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    }
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/*
|--------------------------------------------------------------------------
| Laravel Echo (Websockets via Pusher)
|--------------------------------------------------------------------------
*/

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: true
});